import {
  ComponentConfig,
  LayoutTypes,
  ComponentType,
  FlexDirection,
} from "../services/types/ComponentTypes";

export const screen_113_parts_issue: ComponentConfig[] = [
  {
    componentType: LayoutTypes.SCREEN_GROUP,
    fabAction: {
      type: "add",
      screenId: "120",
      action: "modulev1/parts_issue",
    },
    title: "Parts issue",
    style: {
      backgroundColor: "#F9FAFB", // bg-gray-50 from design system
    },
    childComponents: [
      {
        componentType: LayoutTypes.GROUP,
        style: {
          backgroundColor: "#ffffff",
          direction: FlexDirection.COLUMN,
          borderRadius: 12, // Design system: rounded-lg (12px)
          padding: 16, // Design system: p-4 (16px)
        },
        childComponents: [
          {
            componentType: ComponentType.SUMMARY_LIST,
            titleValue: "spare_issue_no",
            Name: "parts_issue_summary",
            SummeryActions: [
              {
                Action: {
                  Action: "Navigate",
                  Navigate: "modulev1/parts_issue/<id>",
                },
                ActionType: "Edit",
                ScreenId: "120",
              },
            ],
            Form: {
              Name: "parts_issue_summary",
              TableName: "",
              View: "view_parts_issue_summary",
              DisplayName: "Parts issue",
              Fields: [
                {
                  IncludeLabel: true,
                  Label: "Issue No.",
                  BindValue: "issue_no",
                  Json_Attribute: "spare_issue_no",
                  componentType: ComponentType.TEXT_FIELD,
                  AutoPopulate_format: "SIN_[******]",
                  showInSummary: true,
                } as any,
                {
                  IncludeLabel: true,
                  Label: "Issue date",
                  BindValue: "issue_date",
                  Json_Attribute: "issue_date",
                  componentType: ComponentType.DATE_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Jobcard No.",
                  BindValue: "jobcard_no",
                  Json_Attribute: "jobcard_no",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Job date",
                  BindValue: "job_date",
                  Json_Attribute: "job_date",
                  componentType: ComponentType.DATE_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "VIN No.",
                  BindValue: "vin_no",
                  Json_Attribute: "vin_no",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
              ],
            },
          },
        ],
      },
    ],
  },
];
